import { plainText, richText } from '../../../../modules/validators';
import { trimSpacesLeft } from '../../../../modules/formatters';
import { FormVmItemConfigType } from '../../../../infrastructure/form-viewmodel-controller';
import { DESCRIPTION as DESCRIPTION_LABEL } from '../../../../constants/common-labels.constants';
import { buildConfigList } from '../../../../infrastructure/utils/form-config.utils';
import { PodiumAccessType } from '../../../../api/podium.dao';
import { DEFAULT_PARTICIPANTS_LABEL } from '../../../_events/_manage-event/_connections/_meeting-connections-form/podium-form/podium-form.texts';

export enum FieldKey {
    NAME = 'name',
    DESCRIPTION = 'description',
    GUIDELINES = 'guidelines',
    CONNECTION_VERSION = 'connectionVersion',
    AUTO_REGISTRATION_ENABLED = 'autoRegistrationEnabled',
    AUTO_SUBSCRIPTION_ENABLED = 'autoSubscriptionEnabled',
    PODIUM_LINK_ENABLED = 'podiumLinkEnabled',
    PODIUM_PRESENTER_VIEW_ENABLED = 'podiumPresenterViewEnabled',
    PODIUM_PARTICIPANTS_ENABLED = 'podiumParticipantsEnabled',
    PODIUM_ATTENDEES_ENABLED = 'podiumAttendeesEnabled',
    PODIUM_CHAT_ENABLED = 'podiumChatEnabled',
    PODIUM_QUESTION_ANSWER_ENABLED = 'podiumQuestionAnswerEnabled',
    PODIUM_ACCESS_TYPE = 'podiumAccessType',
    PODIUM_PARTICIPANTS_LABEL = 'podiumParticipantsLabel',
}

export const FORM_CONFIG = {
    [FieldKey.NAME]: {
        labelDescriptor: { id: 'oe.templates.connection.name', defaultMessage: 'Name', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [FieldKey.DESCRIPTION]: {
        labelDescriptor: DESCRIPTION_LABEL,
        defaultValue: '',
        validators: [plainText.maxLength.long],
        formatters: [trimSpacesLeft]
    },
    [FieldKey.GUIDELINES]: {
        labelDescriptor: { id: 'oe.templates.connection.guidelines', defaultMessage: 'Meeting Guidelines', description: 'Label text' },
        defaultValue: '',
        validators: [richText.maxLength.short],
    },
    [FieldKey.CONNECTION_VERSION]: {
        defaultValue: true
    },
    [FieldKey.AUTO_REGISTRATION_ENABLED]: {
        defaultValue: false
    },
    [FieldKey.AUTO_SUBSCRIPTION_ENABLED]: {
        defaultValue: false
    },
    [FieldKey.PODIUM_LINK_ENABLED]: {
        defaultValue: false
    },
    [FieldKey.PODIUM_PRESENTER_VIEW_ENABLED]: {
        defaultValue: false
    },
    [FieldKey.PODIUM_PARTICIPANTS_ENABLED]: {
        defaultValue: true
    },
    [FieldKey.PODIUM_ATTENDEES_ENABLED]: {
        defaultValue: false
    },
    [FieldKey.PODIUM_CHAT_ENABLED]: {
        defaultValue: true
    },
    [FieldKey.PODIUM_QUESTION_ANSWER_ENABLED]: {
        defaultValue: true
    },
    [FieldKey.PODIUM_ACCESS_TYPE]: {
        defaultValue: PodiumAccessType.oeCentralSignIn
    },
    [FieldKey.PODIUM_PARTICIPANTS_LABEL]: {
        defaultValue: DEFAULT_PARTICIPANTS_LABEL,
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
